import type { AgentUpdateState } from '@kirin/api-client/contracts/agent-auto-update';

/** KIR-5191: the label the dashboard shows for each update state. */
export const AGENT_UPDATE_STATE_LABELS: Record<AgentUpdateState, string> = {
  up_to_date: 'Up to date',
  updating: 'Updating',
  pending_reboot: 'Finishes after restart',
  needs_attention: 'Needs attention',
  update_failed: 'Update failed',
  pinned_by_mdm: 'Managed by MDM',
  not_available: 'Auto-update not available',
  off: 'Off',
};
